import { objToQueryString,  IQueryString } from '../../shared/models';

export class ThreadsFilter implements IQueryString {
     regions: number[];

     constructor(obj: any) {
         Object.assign(this, obj);
     }

     toQueryString(): string {
        let payload = {
            regions: this.regions,
        };
        return objToQueryString(payload);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/models/threads-filter.ts